import React, { FC } from 'react';
import { BlockType } from '../../../config/api/models/Block';
import { Icons, SvgIcon } from '../../shared/components';
import { styled, Theme } from '@material-ui/core';

type BlockIconProps = {
  type: BlockType;
};

const Wrapper = styled('div')<Theme>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: '1rem',
  color: theme.palette.primary.main,
  marginRight: '1rem',
}));

export const BlockIcon: FC<BlockIconProps> = ({ type }) => {
  const icon = {
    wysiwyg: undefined,
    study_guide: undefined,
    h5p: Icons.EXERCISES,
    book_widget: Icons.EXERCISES,
    video: Icons.BLOCK_TYPE_VIDEO,
    iframe: Icons.BLOCK_TYPE_IFRAME,
    algebra_kit: Icons.EXERCISES,
    column: Icons.COLUMN,
    cluster: Icons.COLUMN,
    section: Icons.ADD_CHAPTER_CHILD,
    text_exercise: Icons.EXERCISES,
  }[type];

  return icon ? (
    <Wrapper>
      <SvgIcon icon={icon} style={{ marginTop: 3 }} />
    </Wrapper>
  ) : null;
};
